export default {
  apiserver1: "http://localhost:1995/app",
  fileserver1: "http://localhost:1995/uploads/",
  apiserver: "https://server.mohtashamgold.ir/app",
  fileserver: "https://server.mohtashamgold.ir/uploads/",
};
